import React,{ Component } from 'react'


class ProductoGal extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      principal:"",
    }
    this.cambia = this.cambia.bind(this)
  	}

	cambia(fuente,e){
		this.setState({
        	principal:fuente
        })
	}

	componentDidMount(){
		//console.log(this.props)
	}

	componentDidUpdate(prevProps, prevState){
		/*if(this.state.principal=="" || this.props.img!=this.state.principal){
			this.setState({
	        	principal:this.props.img
	        })
		}*/
	}

	render(){
		return (
			 <div className="productoGal">
			 	<div>
					<img src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+this.props.img+"?alt=media"} width="100%" id="img_cont"/>
			 	</div>
				<section className="row  align-items-center">
				{ /*galItems*/ }
				</section>
			</div>
		)
	}

};

export default ProductoGal;



// WEBPACK FOOTER //
// ./src/components/prodgal.js